<template>
  <TemplatePromise v-slot="{ args, resolve }">
    <AppDataGridLookup
      v-bind="{ ...args[0] }"
      @cancel="resolve([])"
      @confirm="resolve"
			@filtersChanged="onFiltersChanged"
		>
			<template #actions="props"><slot name="actions" v-bind="props"></slot></template>
		</AppDataGridLookup>
  </TemplatePromise>
</template>

<script setup lang="ts">
import { Resource } from "@q-food/q-food";

const TemplatePromise = createTemplatePromise<
	string[],
	[
		{
			resource: Resource;
			gridKey?: string;
			selectionMode?: "singleRow" | "multiRow";
			customResourceUrl?: string;
			filters?: string;
			rsqlFilters?: string;
		},
	]
>({
	singleton: true,
});

const emit = defineEmits(["filtersChanged"]);
const onFiltersChanged = (filterModel) => {
	emit("filtersChanged", filterModel);
};

defineExpose({
	start: TemplatePromise.start,
});
</script>

<style scoped></style>
